<template>
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table
                        :settings="tableConfig"
                        :table-items="tableItems"
                        :tbody-tr-class="rowClass"
                        @link-case="linkCaseItem"
                        @load-items="getTableData"

                        @get-selected="openModalCreateRWO"
                        @export="exportCSV" ref="gofixTable">
                            <template slot="gofix_table:reported_time" slot-scope="row">
                                {{row.item.reported_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:repeated_feedback" slot-scope="row">
                                {{(row.item.repeated_feedback && row.item.repeated_feedback.length) ? (row.item.repeated_feedback.length - 1) : 0}}
                            </template>
                            <template slot="gofix_table:order_number" slot-scope="row">
                                <span class="checklistLink" @click="gotoOrderNumber(row.item)"> {{ row.item.order_number }} </span>
                            </template>

                            <template slot="gofix_table:case_number" slot-scope="row">
                                <router-link v-if="row.item.case_number != null" class-active="active" :to="`/case/${row.item.id}`" target="_blank"><span>{{row.item.case_number}}</span></router-link>
                            </template>
                        </gofix-default-table>

                        <b-modal :no-close-on-backdrop="true" id="modal-RaiseACase" title="Create RWO" hide-footer :centered="true" :no-close-on-esc="true" v-model="modals.order.open">
                            <b-form class="formV2">
                                <b-row>
                                    <b-col md="12">
                                        <gofix-form-supplier label="Supplier" :contract-id="ClientContractID ? ClientContractID.id:null" :service-category-id="modals.order.caseSelected ? modals.order.caseSelected.service_category_id : null" :property-id="modals.order.caseSelected ? modals.order.caseSelected.location_id : null" :filterable="false" @change="selectSupplier" v-model="modals.order.data.supplier">
                                        </gofix-form-supplier>
                                    </b-col>
                                    <b-col md="12">
                                        <gofix-form-dropdown label="FM Staff" vLabel="user_name" :filterable="false" @search="searchUser" v-model="modals.order.data.officer_in_charge_id" :options="modals.order.fmStaffData">
                                            <template #gofixInput:dropdown:option="option">
                                                {{option.user_name}} - {{option.role_name}}
                                            </template>
                                            <template #gofixInput:dropdown:selected-option="option">
                                                {{option.user_name}} - {{option.role_name}}
                                            </template>
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                                <b-button-group class="d-block text-right">
                                    <gofix-button label="SUBMIT" @click="createRWO" :loading="modals.order.loading" noBorder></gofix-button>
                                </b-button-group>
                            </b-form>


                        </b-modal>
                        
                        <b-modal :no-close-on-backdrop="false" id="modal-AnotherCase" v-if="email !== null && email.case !== null" :title="`If you Relink the email to another case, all activities related to the email in ${email.case.case_number}  will be deleted. Do you want to proceed?`" hide-footer :centered="true" v-model="modals.another_case.open">
                            <b-form class="formInvoice pb-10">
                                <b-row>
                                    <b-col md="6">
                                        <gofix-button label="Cancel" @click="closeAnotherCaseLinkage" :loading="modals.another_case.loading" noBorder></gofix-button>
                                    </b-col>

                                    <b-col md="6">
                                        <gofix-button label="Confirm" @click="anotherCaseLinkage" :loading="modals.another_case.loading" noBorder></gofix-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                            <!-- <b-button-group class="d-block text-left">
                                <gofix-button label="Cancel" @click="createRWO" :loading="modals.another_case.loading" noBorder></gofix-button>
                            </b-button-group>
                            <b-button-group class="d-block text-right">
                                    <gofix-button label="Confirm" @click="createRWO" :loading="modals.another_case.loading" noBorder></gofix-button>
                            </b-button-group> -->
                        </b-modal>

                            <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.remark.title" hide-footer :centered="true" v-model="modals.remark.open">
                                <b-form class="formInvoice pb-10">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-input-date
                                                label="Action Date"
                                                popoverDirection="top"
                                                :required="true"
                                                :show-icon-required="true"
                                                v-model="modals.remark.data.date" >
                                            </gofix-form-input-date>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-input-time
                                                label="Action Time"
                                                popoverDirection="top"
                                                :required="true"
                                                :show-icon-required="true"
                                                v-model="modals.remark.data.time" >
                                            </gofix-form-input-time>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="12">
                                            <gofix-form-dropdown
                                                    label="Actor"
                                                    desc="Search by email"
                                                    @search="searchUser"
                                                    :filterable="false"
                                                    :required="true"
                                                    :show-icon-required="true"
                                                    v-model="officerName"
                                                    :options="fmOfficer">
                                                <template #gofixInput:dropdown:option="{ user_name, user_email }">
                                                    {{user_name}} - {{user_email}}
                                                </template>
                                                <template #gofixInput:dropdown:selected-option="{ user_name, user_email }">
                                                    {{user_name}} - {{user_email}}
                                                </template>
                                            </gofix-form-dropdown>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="12">
                                            <gofix-form-dropdown
                                                label="Activity"
                                                :clearable="true"

                                                :show-icon-required="true"
                                                vLabel="reference_value_text"
                                                v-model="modals.remark.data.action"
                                                :required="true"
                                                :options="activities">
                                                <template #gofixInput:dropdown:option="{ reference_value_text }">
                                                    {{reference_value_text}}
                                                </template>
                                                <template #gofixInput:dropdown:selected-option="{ reference_value_text }">
                                                    {{reference_value_text}}
                                                </template>
                                            </gofix-form-dropdown>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="12">
                                            <gofix-form-input-textarea :rows="5" :show-icon-required="true" label="Remark" :required="true" v-model="modals.remark.data.remark"></gofix-form-input-textarea>
                                        </b-col>
                                    </b-row>
                                  

                                </b-form>
                                <b-button-group class="d-block text-right">
                                    <gofix-button v-if="this.modals.remark.data.id && contracts && contracts.case_settings && contracts.case_settings.is_use_nlt_case_module" label="UPDATE & CHANGE STATUS" @click="saveActivity(true)" :loading="modals.remark.loading_save_status" noBorder></gofix-button>
                                    <gofix-button v-if="!this.modals.remark.data.id && contracts && contracts.case_settings && contracts.case_settings.is_use_nlt_case_module" label="SAVE & UPDATE STATUS" @click="saveActivity(true)" :loading="modals.remark.loading_save_status" noBorder></gofix-button>
                                    <gofix-button :label="modals.remark.button_label" @click="saveActivity(false)" :loading="modals.remark.loading" noBorder></gofix-button>
                                </b-button-group>
                            </b-modal>
                    </gofix-card>

</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'
export default {
    name: 'case_list',
     props: ['email_id','email'],
    data() {
        let filter = JSON.parse(JSON.stringify(filters['case_list']));
        return {
            tableConfig: {
                name: 'case-list',
                controls: {
                    create:false,
                    linkCase: true,
                    delete: false,
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
                sortColumn: "id",
                sortDirection: "desc",
            },
            tableItems: [],
            modals: {
                order: {
                    open: false,
                    loading: false,
                    data: {
                        supplier: null,
                        supplier_id: null,
                        officer_in_charge_id: null,
                    },
                    ids: [],
                    caseSelected: null,
                    supplierData: [],
                    supplierDataTimeOut: null,
                    fmStaffData: [],
                    fmStaffDataTimeOut: null,
                    fmStaffDataLoading: false
                },
                another_case:
                {
                    open: false,
                    loading: false,
                    data: null
                },
                remark:{
                        open:false,
                        loading:false,
                        loading_save_status: false,
                        data:{
                            id:null,
                            remark: null,
                            date:null,
                            time:null,
                            time_stamp:null,
                            actor:null,
                            actor_id:null,
                            action:null,
                            log_type:'Manual',
                        },
                        attachments: [],
                        attachmentUpdate: [],
                        attachmentDeleteId: [],
                        attachment_tmp: {
                            delete: [],
                            add:[],
                            update: []
                        },
                        title: 'Create Activity Log',
                        button_label:'Save'
                    },
            },
            contracts: {
                id:null
            },
            case:{
                id:null
            },
            officerName:null,
            fmOfficer:[],
            activities:[],
            timer: {
                activity: null,
            }
        }
    },
    watch: {
        "currentRoles": function(val, old) {
            this.tableConfig.controls = {
                create: this.$checkRole(this.$accessModule.case_management, 'create'),
                sendSelected: this.$checkRole(this.$accessModule.order, 'create'),
                sendSelectedText: "Create RWO",
                tableImport: false
            }
        },
    },
    computed: {
        ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID',
            currentRoles: 'AuthController/roles',
            UserLogin: "AuthController/user",
        })
    },
    async created() {

    },
    async mounted(){

    },
    methods: {
        /*---------- Table event ----------*/
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            await this.$store.dispatch("CaseManagementController/getList", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;

                    resolve(response.data.data);
                })
                .catch(err => {
                    this.$alertNotification("Can not load the case management", "danger");
                    reject();
                })
        },
        closeAnotherCaseLinkage(){
            this.modals.another_case.open=false;
        },
        anotherCaseLinkage()
        {
            this.modals.another_case.open=false;
            console.log(this.modals.another_case.data);
            
            this.linkCaseCall(this.modals.another_case.data);
            // this.modals.another_case.data

        },
        async linkCaseItem(callback) {
            // ids is caseId
            const { ids, filter, resolve, reject } = await callback();
            let SelectedItem = this.tableItems.find(element => ids == element.id);
            this.modals.another_case.data = SelectedItem;

            
            if(SelectedItem.status=="Closed")
            {
              return this.$alertNotification('Link an email a closed case is not allowed', 'danger');
            }

            if(this.email.case)
            {
               this.modals.another_case.open=true;
            }


            if(!this.modals.another_case.open)
            {
            
                await this.getFMUsers(SelectedItem.client_contract_id);
                this.modals.remark.data.date = null;
                this.modals.remark.data.time = null;
                
                
                if(this.email !==null){
                    

                    if(this.email.received_time !==null){
                        // console.log(new Date(this.email.date));
                        // console.log(this.email.date);
                        // console.log(moment(this.email.date,"DD MM YYYY HH mm",true).format("DD-MM-YYYY"));
                        

                        this.modals.remark.data.date = new Date(this.email.received_time);
                        this.modals.remark.data.time = moment(new Date(this.email.received_time)).format("HH:mm");
                    }else
                    {
                        

                        var received_date = moment(this.email.date, 'DD/MM/YYYY HH:mm');
                        let month=received_date.month()+1;
                        
                
                        this.modals.remark.data.date = new Date(received_date.year()+'-'+month+'-'+received_date.date()); 
                        this.modals.remark.data.time = received_date.format("HH:mm");
                    }

                    
                }else
                {
                    // console.log("null");
                    // console.log(moment().format("dd.mm.YYY"));
                    this.modals.remark.data.date = new Date(); 
                    this.modals.remark.data.time = moment().format("HH:mm");
                }

                

                // console.log("linkcase");
                this.case.id = SelectedItem.id;
                this.contracts.id=SelectedItem.client_contract_id;

                

                let filters = {"reference_type":"Case Activity","contract_id":this.contracts.id};
                let request = {
                    limit: -1, 
                    sortColumn:'id',
                    sortDirection:'asc',
                    filter: filters
                };
                this.timer = setTimeout(() => {
                    this.$store.dispatch("ReferenceController/getItems", request)
                        .then(response => {
                            this.activities = response.items;
                        
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
                this.modals.remark.open=true;
            }
           
        },

        linkCaseCall(SelectedItem)
        {
            this.getFMUsers(SelectedItem.client_contract_id);
                this.modals.remark.data.date = null;
                this.modals.remark.data.time = null;
                
                
                if(this.email !==null){
                    

                    if(this.email.received_time !==null){
                        // console.log(new Date(this.email.date));
                        // console.log(this.email.date);
                        // console.log(moment(this.email.date,"DD MM YYYY HH mm",true).format("DD-MM-YYYY"));
                        

                        this.modals.remark.data.date = new Date(this.email.received_time);
                        this.modals.remark.data.time = moment(new Date(this.email.received_time)).format("HH:mm");
                    }else
                    {
                        

                        var received_date = moment(this.email.date, 'DD/MM/YYYY HH:mm');
                        let month=received_date.month()+1;
                        
                
                        this.modals.remark.data.date = new Date(received_date.year()+'-'+month+'-'+received_date.date()); 
                        this.modals.remark.data.time = received_date.format("HH:mm");
                    }

                    
                }else
                {
                    // console.log("null");
                    // console.log(moment().format("dd.mm.YYY"));
                    this.modals.remark.data.date = new Date(); 
                    this.modals.remark.data.time = moment().format("HH:mm");
                }

                

                // console.log("linkcase");
                this.case.id = SelectedItem.id;
                this.contracts.id=SelectedItem.client_contract_id;

                

                let filters = {"reference_type":"Case Activity","contract_id":this.contracts.id};
                let request = {
                    limit: -1, 
                    sortColumn:'id',
                    sortDirection:'asc',
                    filter: filters
                };
                this.timer = setTimeout(() => {
                    this.$store.dispatch("ReferenceController/getItems", request)
                        .then(response => {
                            this.activities = response.items;
                        
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
                this.modals.remark.open=true;
        },
         async searchUser (search, loading){

                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                let filter = {user_name:{type:"text",value:'',function:"ilike",with:[]},user_email:{type:"text",value:search,function:"ilike",with:[]},user_type:{type:"text",value:"FM Officer",function:"ilike",with:[]},contract_id:{type:"number",value: this.contracts.id,function:"=",with:[]}};
                let request = {
                    limit: 100,
                    page: 1,
                    isCMS:1,
                    sortColumn:'user_id',
                    sortDirection:'ASC',
                    filter: filter,
                    useDatabaseView:true
                };
                this.timer = setTimeout(() => {
                    this.$store.dispatch("UserDutyController/getItems", request)
                        .then(response => {
                            this.fmOfficer = response.items;
                            loading(false)
                        })
                        .catch(err=>{
                            // loading(false)
                            })
                }, 500);
        },
        async saveActivity(is_allow_change_status = false){
            //  this.email_id, this.case.id = SelectedItem.id;  this.contracts.id=SelectedItem.client_contract_id;

            if (this.timer.activity) {
                clearTimeout(this.timer.activity);
                this.timer.activity = null;
            }
            this.timer.activity = setTimeout(async () => {
                if (this.modals.remark.loading) return;
                this.modals.remark.loading = true;
                
                if(!this.modals.remark.data.date || 
                        !this.modals.remark.data.time || 
                        !this.officerName || 
                        // !this.modals.remark.data.action || 
                        !this.modals.remark.data.remark){
                        return this.$alertNotification('Please enter all fields!', 'danger');
                }


                let action = "createLogCase"
                let params = {};

                

                if(this.officerName){
                        this.modals.remark.data.actor_id = this.officerName.user_id;
                        this.modals.remark.data.actor = this.officerName.user_name;
                }

                // this.activities;
                // console.log(this.activities);
                // params.action.normalize() === element.reference_value_text.normalize()
                let activityType = this.activities.find(element => params.action === element.reference_value_text );

                params = Object.assign({
                            work_item_type: "Case",
                            work_item_id: this.case.id,
                            is_allow_change_status:"true",
                            nlt_case_key_action: this.modals.remark.data.action.reference_value_abbr,
                        }, this.modals.remark.data);

                params.time_stamp = moment(params.date).format("YYYY-MM-DD") + ' ' + params.time;

                delete params['date'];
                delete params['time'];


                params.action = this.modals.remark.data.action.reference_value_text;
                // params.nlt_case_key_action = activityType.reference_value_abbr ? activityType.reference_value_abbr : null
                // params.is_allow_change_status = is_allow_change_status;
                params.email_id=this.email_id;

                // alert(params.time_stamp);
                let request = Object.assign({
                            email_id: this.email_id,
                            locked:true,
                            status:"Linked To Case",
                            case_id:this.case.id
                            // received_time:params.time_stamp
                        });
                

                this.$store.dispatch("EmailIntegrationController/locked", request)
                    .then(response => {

                        
                        // if(response.data.data == 1){
                        //     // this.modals.assign.email_id=SelectedItem.id;
                        //     // this.modals.assign.open=true;
                        //     // this.$router.push(`/v2/case/0/${ids}`);
                        // }
                    })
                    .catch(err => {
                    return this.$alertNotification("Sorry, Linked to Case Unsuccessful", "danger");

                    })

                
                    await this.$store.dispatch('ActivityLogsController/updateByEmail', params).then(response => {
                        
                        


                        }).catch(err => {
                            return this.$alertNotification("Sorry, Linked to Case Unsuccessful", "danger");
                        })
                
                
                

                this.$store.dispatch('ActivityLogsController/create', params)
                        .then(response => {
                            this.$alertNotification('Activity log has been created!', 'success');
                            this.modals.remark.open=false;
                            this.$router.push(`/case/${response.work_item_id}`);
                            // location.reload();


                        })
                        .catch(err => {
                            // this.modals.remark.loading_save_status = false
                            // this.modals.remark.loading = false;
                        })
            }, 300);
         },



        async deleteItems(callback) {
            const { ids, filter, resolve, reject } = await callback();
            this.$store.dispatch("CaseManagementController/deteleItem", ids)
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'case'))
                })
                .catch(err => {
                    reject(err);
                });
        },

        gotoOrderNumber(item) {
            if (item.work_order_id) {
                this.$router.push(`/v2/orders/${item.work_order_id}`);
            }
        },
        /*----------------------------------------*/

        /*------ Component event  (Load + config data)-----------------*/
        searchSupplier(search, loading) {
            this.modals.order.supplierData = []
            loading(true);
            if (this.modals.order.supplierDataTimeOut) {
                clearTimeout(this.modals.order.supplierDataTimeOut);
                this.modals.order.supplierDataTimeOut = null;
            }
            this.modals.order.supplierDataTimeOut = setTimeout(() => {
                try {
                    this.getSupplier({ contract_id: this.ClientContractID.id, name: search }, 100);
                    loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        getSupplier(filter = {}, limit = 100) {
            filter['is_supplier'] = true
            this.$store.dispatch('OrganizationController/searchItemsInUser', { filter: filter, limit: limit })
                .then(response => {
                    this.modals.order.supplierData = response.data.data.items
                })
        },
        selectSupplier(item) {
            if (item) {
                this.modals.order.data.supplier_id = item.id
                /*this.modals.order.fmStaffDataLoading = true;
                this.getUser({ organisation_id: item.id });*/
            }
        },
        async getFMUsers(contract_id)
        {
             let filter = {user_name:{type:"text",value:"",function:"ilike",with:[]},user_email:{type:"text",value:"",function:"ilike",with:[]},user_type:{type:"text",value:"FM Officer",function:"ilike",with:[]},contract_id:{type:"number",value:contract_id,function:"=",with:[]}};
                let request = {
                    limit: 100,
                    page: 1,
                    isCMS:1,
                    sortColumn:'user_id',
                    sortDirection:'ASC',
                    filter: filter,
                    useDatabaseView:true
                };
                this.$store.dispatch("UserDutyController/getItems", request)
                    .then(result=>{
                        this.fmOfficer = result.items;

                        //load login user as default Actor
                        let offName = this.fmOfficer.filter(val => val.user_id === this.UserLogin.id);
                        if(offName.length > 0){
                            this.officerName = offName[0];
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
        },
        getUser(contract_id, property_id, search = null, limit = 100) {
            this.$store.dispatch("v2UserController/getAccessFmUsers", {
                    contract_id: contract_id,
                    property_id: property_id,
                    section_name: ["Case Management"],
                    module_name: ["Case"],
                    //group_user:true,
                    filter: { name: search || null }
                })
                .then(response => {
                    this.modals.order.fmStaffData = response.items;
                    this.modals.order.fmStaffDataLoading = false;
                    if (!search) {
                        let activeUser = this.modals.order.fmStaffData.find(element => element.user_id === this.modals.order.data.officer_in_charge_id.user_id);
                        this.modals.order.data.officer_in_charge_id.role_name = activeUser.role_name;
                    }
                })
                .catch(err => { this.modals.order.fmStaffDataLoading = false; })
        },
        // searchUser(search, loading) {
        //     loading(true);
        //     this.modals.order.caseSelected = this.tableItems.find(element => element.id === this.modals.order.ids[0]);
        //     if (this.modals.order.fmStaffDataTimeOut) {
        //         clearTimeout(this.modals.order.fmStaffDataTimeOut);
        //         this.modals.order.fmStaffDataTimeOut = null;
        //     }
        //     this.modals.order.fmStaffDataTimeOut = setTimeout(() => {
        //         this.getUser(this.modals.order.caseSelected.client_contract_id, this.modals.order.caseSelected.location_id, search);
        //         loading(false);
        //     }, 300);
        // },
        openModalCreateRWO(ids, filter) {
            if (!this.ClientContractID || !this.ClientContractID.id) {
                return this.$alertNotification("Please select a contract before create RWO.", "danger");
            }

            if (ids.length === 0 || ids.length > 1) {
                return this.$alertNotification("Please select only 1 item to create RWO.", "danger");
            }

            this.modals.order.ids = ids;
            this.modals.order.data = {
                supplier: null,
                supplier_id: null,
                officer_in_charge_id: null,
            };

            //Get case
            this.modals.order.caseSelected = this.tableItems.find(element => element.id === ids[0]);
            this.getUser(this.modals.order.caseSelected.client_contract_id, this.modals.order.caseSelected.location_id);
            this.modals.order.data.supplier = this.modals.order.caseSelected ? this.modals.order.caseSelected.supplier : null;
            this.modals.order.data.supplier_id = this.modals.order.caseSelected ? this.modals.order.caseSelected.supplier_id : null;
            this.modals.order.data.officer_in_charge_id = {
                user_id: this.modals.order.caseSelected ? this.modals.order.caseSelected.officer_in_charge_id : null,
                user_name: (this.modals.order.caseSelected && this.modals.order.caseSelected.user) ? this.modals.order.caseSelected.user.name : null,
                role_name: null
            }

            this.modals.order.open = true;
        },
        /*----------------------------------------*/
        exportCSV() {
            this.$store.dispatch('CaseManagementController/exportCsv')
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'CaseList.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
        },
        /*---- Component event  (Save Data) ------------------------------------*/
        createRWO() {
            if (!this.modals.order.data.supplier_id) {
                return this.$alertNotification("Supplier is a required field.", "danger");
            }

            if (!this.modals.order.data.officer_in_charge_id) {
                return this.$alertNotification("FM Staff is a required field.", "danger");
            }
            if (this.modals.order.loading) return;

            let itemSelect = this.tableItems.filter(item => this.modals.order.ids.includes(item.id))

            let request = {
                type: "Case",
                item_id: itemSelect[0].id,
                supplier_id: this.modals.order.data.supplier_id,
                officer_in_charge_id: this.modals.order.data.officer_in_charge_id.user_id,
            };
            this.$store.dispatch(`OrderController/raiseOrder`, request)
                .then(response => {
                    this.$alertNotification(this.$notificationV2('adding', 'order'));
                    this.modals.order.loading = false;
                    this.modals.order.open = false;
                    this.$refs.gofixTable.reloadTableKeepFilter();
                })
                .catch(err => {
                    this.modals.order.loading = false;
                    this.$alertNotification("Can't create order", "danger");
                });
        },
        /*----------------------------------------*/
        rowClass(item, type) {
            if (item) {
                if (item.status === "Open") {
                    return 'row-case-new';
                }
            }
            return null;
        }
    }
}
</script>
